import React, { useEffect, useRef } from "react";
import PopupMask from "@/componentsUI/PopupMask/popupMask";
import styles from "./index.module.less";

interface RechargeTutorialProps {
  title: string;
  hint: string;
  videoUrl: string;
  visible: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const RechargeTutorial: React.FC<RechargeTutorialProps> = ({
  title,
  hint,
  videoUrl,
  visible,
  onOpen,
  onClose,
}) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (!visible && videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [visible]);

  return (
    <>
      <button type="button" className={styles.card} onClick={onOpen}>
        <span className={styles.playBadge} aria-hidden="true">
          <svg viewBox="0 0 24 24" className={styles.playIcon}>
            <path d="M8 5.5v13l10-6.5-10-6.5z" />
          </svg>
        </span>
        <span className={styles.texts}>
          <span className={styles.title}>{title}</span>
          <span className={styles.hint}>{hint}</span>
        </span>
      </button>
      <PopupMask visible={visible} onClose={onClose} className={styles.popupMask}>
        <div className={styles.modal} role="dialog" aria-label={title}>
          <div className={styles.modalHeader}>
            <div className={styles.modalTitle}>{title}</div>
            <button
              type="button"
              className={styles.closeBtn}
              onClick={onClose}
              aria-label="Close"
            >
              ×
            </button>
          </div>
          <div className={styles.modalBody}>
            <div className={styles.videoShell}>
              <video
                ref={videoRef}
                className={styles.video}
                src={videoUrl}
                controls
                playsInline
                preload="metadata"
              />
            </div>
          </div>
        </div>
      </PopupMask>
    </>
  );
};

export default RechargeTutorial;
